import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedModule} from "../shared/shared.module";
import {ApiResourceDataService} from "./api-resource-data.service";
import {ApiScopeDataService} from "./api-scope-data.service";



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
    {provide: ApiResourceDataService, useClass: ApiResourceDataService, multi: false},
    {provide: ApiScopeDataService, useClass: ApiScopeDataService, multi: false}
  ]
})
export class IdentityServerDataModule { }
